<template>
  <div>
    <div class="page-content">
      <div class="container-fluid">
        <div class="card">
          <div class="card-head">轮播图配置</div>
          <div class="card-body padding-top0">
            <div class="card-menu">
              <Button type="primary" icon="md-add" @click="addClick" style="margin-right: 10px">新增</Button>
              <Button type="error" icon="md-trash" @click="allDel" :disabled="Selection.length==0?true:false">删除</Button>
            </div>
            <div v-if="data.length == 0 && !load">
              <Empty :text="'暂无数据'"></Empty>
            </div>
            <div v-else>
              <Alert show-icon border :loading="load" v-if="$store.state.isMobile">移动设备请左右滑动翻阅</Alert>
              <Table border ref="selection" :columns="columns" :data="data" @on-selection-change="handleSelectChange">
                <template slot-scope="{ row }" slot="img">
                  <img :src="row.img" alt="" class="swipe-img" />
                </template>
                <template slot-scope="{ row }" slot="status">
                  <Badge v-if="row.status === 0" status="error" text="已停用" />
                  <Badge v-if="row.status === 1" status="success" text="已启用" />
                </template>
                <template slot-scope="{ row }" slot="action">
                  <Button type="primary" size="small" style="margin-right: 5px" @click="editClick(row)">编辑</Button>
                  <Button type="error" size="small" @click="del(row.id)">删除</Button>
                </template>
              </Table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Modal v-model="showCreate" :title="edit ? '编辑轮播图' : '新增轮播图'" :loading="creating" :width="600"
      @on-ok="edit ? editSave() : addSave()">
      <Form ref="create" :model="createData" :rules="createRules" :label-width="110">
        <FormItem label="图片：" prop="img">
          <div class="pictrueBox">
            <div class="pictrue" v-if="createData.img" @click="upload(1)">
              <img :src="createData.img" alt="" />
            </div>
            <div class="upload" @click="upload(1)" v-else>
              <Icon type="ios-camera" size="30"></Icon>
            </div>
          </div>
        </FormItem>

        <FormItem label="跳转地址：" prop="url">
          <Input v-model="createData.url" placeholder="http://" />
        </FormItem>

        <FormItem label="状态：" prop="status">
          <i-switch v-model="createData.status" :true-value="1" :false-value="0" />
        </FormItem>
      </Form>
    </Modal>
    <UploadPictures @use="use"></UploadPictures>
  </div>
</template>

<script>
  import {
    getSwipe,
    postSwipe,
    delSwipe,
    putSwipe
  } from "@/api/admin";
  export default {
    data() {
      return {
        Selection: [],
        showCreate: false,
        creating: true,
        edit: false,
        createData: {
          img: "",
          url: "",
          status: 1,
        },
        createRules: {
          img: [{
            required: true,
            message: "请上传图片",
            trigger: "blur"
          }],
          url: [{
            required: true,
            message: "请输入跳转地址",
            trigger: "blur"
          }],
        },
        columns: [{
            type: "selection",
            width: 60,
            align: "center",
          },

          {
            title: "图片",
            key: "img",
            align: "center",
            slot: "img",
            minWidth: 100,
          },
          {
            title: "跳转地址",
            key: "url",
            align: "center",
            minWidth: 230,
          },

          {
            title: "状态",
            align: "center",
            slot: "status",
            minWidth: 100,
          },
          {
            title: "操作",
            minWidth: 130,
            align: "center",
            slot: "action",
          },
        ],
        data: [],
        load:true
      };
    },
    created() {
      this._getData();
    },

    methods: {
      // 获取列表
      _getData() {
        getSwipe().then((res) => {
          this.data = res.data;
          this.load = false
        });
      },

      // 调用上传组件
      upload(num) {
        this.$store.state.showBase = true;
      },

      // 使用图片传值
      use(val) {
        let long = val.length;
        if (long == 1) {
          this.createData.img = val[0];
          this.$store.state.showBase = false;
        } else {
          this.$Message.warning({
            background: true,
            content: "一次最多选择1张图片",
          });
        }
      },
      // 删除
      del(id) {
        this.$Modal.confirm({
          title: "删除确认",
          content: "删除活动后无法恢复，是否继续？",
          onOk: () => {
            this.delFunction(id);
          },
        });
      },

      // 删除所选
      allDel() {
        let arr = [];
        this.Selection.map(function (item) {
          arr.push(item.id);
        });
        this.del(arr);
      },
      // 删除方法
      delFunction(id) {
        this.load = true
        delSwipe({
          id: id,
        }).then((res) => {
          if (res.code == 200) {
            this.$Message.success({
              background: true,
              content: res.msg,
            });
            this._getData();
          } else {
            this.$Message.error({
              background: true,
              content: res.msg,
            });
          }
        });
      },

      //  新增按钮
      addClick() {
        this.edit = false;
        this.showCreate = true;
        this.createData.img = "";
        this.createData.url = "";
        this.createData.status = 1;
      },

      // 新增方法
      addSave() {

        this.$refs.create.validate((valid) => {
          if (valid) {
            postSwipe({
              img: this.createData.img,
              url: this.createData.url,
              status: this.createData.status,
            }).then((res) => {
              if (res.code == 200) {
                this.$Message.success({
                  background: true,
                  content: res.msg,
                });
                this._getData();
              } else {
                this.$Message.error({
                  background: true,
                  content: res.msg,
                });
              }
            });
            this.showCreate = false;
            this.creating = false;
            this.$nextTick(() => {
              this.creating = true;
            });
          } else {
            this.creating = false;
            this.$nextTick(() => {
              this.creating = true;
            });
          }
        });
      },

      //  编辑按钮
      editClick(row) {
        this.edit = true;
        this.showCreate = true;
        this.createData = {
          ...row
        };
      },

      // 编辑方法
      editSave() {

        this.$refs.create.validate((valid) => {
          if (valid) {
            putSwipe({
              id: this.createData.id,
              img: this.createData.img,
              url: this.createData.url,
              status: this.createData.status,
            }).then((res) => {
              if (res.code == 200) {
                this.$Message.success({
                  background: true,
                  content: res.msg,
                });
                this._getData();
              } else {
                this.$Message.error({
                  background: true,
                  content: res.msg,
                });
              }
            });
            this.showCreate = false;
            this.creating = false;
            this.$nextTick(() => {
              this.creating = true;
            });
          } else {
            this.creating = false;
            this.$nextTick(() => {
              this.creating = true;
            });
          }
        });
      },


      //多选
      handleSelectChange(val) {
        this.Selection = val;
      },
    },
  };
</script>

<style lang="less" scoped>
  @deep: ~">>>";

  @{deep}.ivu-radio-wrapper {
    margin-right: 15px;
  }

  .swipe-img {
    margin: 10px auto;
    width: 100px;
    height: 40px;
  }

  .pictrueBox {
    display: block;

    .upload {
      display: inline-block;
      margin-right: 10px;
      width: 200px;
      height: 80px;
      line-height: 80px;
      border: 1px dotted rgba(0, 0, 0, 0.1);
      border-radius: 4px;
      background: rgba(0, 0, 0, 0.02);
      cursor: pointer;
      text-align: center;
    }

    .pictrue {
      width: 200px;
      height: 80px;
      display: inline-block;
      margin-right: 15px;
      vertical-align: middle;
      background: rgba(0, 0, 0, 0.02);
      cursor: pointer;
      position: relative;

      img {
        width: 100%;
        height: 100%;
        vertical-align: middle;
        border-radius: 4px;
      }

      .ivu-btn {
        position: absolute;
        font-size: 12px !important;
        width: 20px;
        height: 20px;
        top: -6px;
        right: -6px;
      }
    }
  }
</style>